import { render, staticRenderFns } from "./Minimoainvertir.vue?vue&type=template&id=644753b6&scoped=true&"
import script from "./Minimoainvertir.vue?vue&type=script&lang=ts&"
export * from "./Minimoainvertir.vue?vue&type=script&lang=ts&"
import style0 from "./Minimoainvertir.vue?vue&type=style&index=0&id=644753b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644753b6",
  null
  
)

export default component.exports